<template>
  <div>
    <div class="input-group mb-3">
      <input class="form-control" type="text" ref="newItemRef" v-model="newItem" @keyup.enter="handleAddItem" />
      <div class="input-group-append">
        <button
          @click.prevent="handleAddItem"
          class="btn btn-outline-secondary"
          type="button"
          style="border: 1px solid #dee2e6"
        >
          Add item
        </button>
      </div>
    </div>

    <ul class="record-items">
      <li v-for="(item, i) in items" :key="`${item}-${i}`" class="record-item">
        <span class="badge badge-pill badge-secondary record-item"
          >{{ item }}
          <i
            v-if="allowDelete"
            @click.prevent="handleDeleteItem(i)"
            class="ml-2 fas fa-times text-danger delete-item"
          ></i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
const ACTION = {
  ADD: 'ADD',
  DELETE: 'DELETE'
};

export default {
  props: {
    defaultValue: {
      type: Array,
      default: () => []
    },
    allowDelete: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!!this.defaultValue.length) {
      this.items = [...this.defaultValue];
    }
  },
  data() {
    return {
      itemRef: null,
      newItem: '',
      items: []
    };
  },
  methods: {
    handleAddItem() {
      if (!this.newItem) return null;

      this.items.push(this.newItem);

      this.$emit('onListChange', {
        action: ACTION.ADD,
        item: this.newItem,
        updatedItems: [...this.items]
      });

      this.$refs.newItemRef.focus();

      this.newItem = '';
    },
    handleDeleteItem(index) {
      const item = this.items[index];

      this.items.splice(index, 1);

      this.$emit('onListChange', {
        action: ACTION.DELETE,
        item,
        updatedItems: [...this.items]
      });
    }
  }
};
</script>

<style scoped>
ul.record-items {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
}

li span.record-item {
  font-size: 14px;
}

.delete-item {
  cursor: pointer;
}
</style>